export class SummarySettings {
    public static TODAY_WIND_COUNT: number = 8;
}